import { States } from '../../../../../app.router';

/* @ngInject */
export default class LiveDeskOccupancyCardController {
    constructor(EventEmitter, $scope, $state) {
        this.EventEmitter = EventEmitter;
        this.$scope = $scope;
        this.$state = $state;
    }

    $onInit() {
        this.showDeviceList = false
        this.totalDevices = this.card.content.devices.length
        this.totalOccupied = 0
        this.totalNotOccupied = 0
        this.totalOffline = 0
        this.updateCardStatus()

        // GraphLoading is set to true by dashboard controller when new events are received
        this.$scope.$watch("$ctrl.card.graphLoading", () => {
            this.updateCardStatus()
            this.$scope.$applyAsync()        
        });
    }

    updateCardStatus() {
        let newTotalOffline = 0
        let newTotalOccupied = 0
        let newTotalNotOccupied = 0
        this.card.content.devices.forEach(device => {
            if (device.offline) {
                newTotalOffline += 1
                return
            }
            if (device.reported.deskOccupancy?.state === 'OCCUPIED') {
                newTotalOccupied += 1
            }
            if (device.reported.deskOccupancy?.state === 'NOT_OCCUPIED') {
                newTotalNotOccupied += 1
            }
        })
        this.totalOffline = newTotalOffline
        this.totalOccupied = newTotalOccupied
        this.totalNotOccupied = newTotalNotOccupied
    }

    hoverStarted() {
        this.hoveringOnCard = true
        setTimeout(() => {
            if (this.hoveringOnCard) {
                this.showDeviceList = true
                this.$scope.$applyAsync()
            }
        }, 250);
    }

    hoverStopped() {
        this.hoveringOnCard = false
        this.showDeviceList = false
    }

    getStatusForDevice(device) { // eslint-disable-line class-methods-use-this
        if (device.offline) {
            return 'Offline'
        }
        if (device.reported.deskOccupancy?.state === 'OCCUPIED') {
            return 'Occupied'
        }
        if (device.reported.deskOccupancy?.state === 'NOT_OCCUPIED') {
            return 'Not Occupied'
        }
        return ''
    }

    goToSensorPage(device) {
        this.$state.go(States.SENSOR_DETAILS, {
            projectId: device.name.split('/')[1],
            sensorId: device.name.split('/')[3],
        });
    }
}
